import List from './views/List.vue'
import CreateEdit from './views/CreateEdit.vue'
import Get from './views/Get.vue'

export const SavedFormulaRoutes = [
  {
    path: '/saved-formulas',
    name: 'ListSavedFormulas',
    component: List,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'saved_formula:list'
    }
  },
  {
    path: '/saved-formula/',
    name: 'CreateSavedFormula',
    component: CreateEdit,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'saved_formula:create'
    }
  },
  {
    path: '/saved-formula/:id',
    name: 'UpdateSavedFormula',
    component: CreateEdit,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'saved_formula:update'
    }
  },
  {
    path: '/saved-formula/view/:id',
    name: 'GetSavedFormula',
    component: Get,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'saved_formula:get'
    }
  }
]
